import { useState } from 'react';
import EmbeddedReaderManagement from './EmbeddedReaderManagement';

const OnboardingStep5Readers = ({ onNext, onSkip, isLoading, setIsLoading, stepData }) => {
  const [mode, setMode] = useState(null); // 'add' or null

  const handleAddReaders = (data) => {
    console.log('🔍 OnboardingStep5Readers - handleAddReaders called with:', data);
    onNext(data);
  };

  const handleSkipReaders = () => {
    console.log('🔍 OnboardingStep5Readers - handleSkipReaders called');
    onSkip();
  };

  return (
    <div className="onboarding-step readers-step">
      {!mode ? (
        <div className="readers-content">
          <div className="readers-icon">👥</div>
          
          <p>
            Add family members as readers to track everyone's progress together. 
            This is especially helpful for families with children or multiple people reading.
          </p>

          <div className="readers-info">
            <div className="info-item">
              <div className="info-icon">👤</div>
              <div className="info-text">
                <strong>Primary Reader:</strong> You already have a reader profile created automatically
              </div>
            </div>
            
            <div className="info-item">
              <div className="info-icon">👨‍👩‍👧‍👦</div>
              <div className="info-text">
                <strong>Additional Readers:</strong> Add family members, children, or other household readers
              </div>
            </div>
            
            <div className="info-item">
              <div className="info-icon">📊</div>
              <div className="info-text">
                <strong>Individual Tracking:</strong> Each reader has their own progress and statistics
              </div>
            </div>
          </div>

          <div className="readers-actions">
            <div className="action-card" onClick={() => setMode('add')}>
              <div className="action-icon">➕</div>
              <div className="action-title">Add Family Readers</div>
              <div className="action-description">
                Set up reader profiles for family members
              </div>
            </div>

            <div className="action-card skip-card" onClick={handleSkipReaders}>
              <div className="action-icon">⏭️</div>
              <div className="action-title">Just Me for Now</div>
              <div className="action-description">
                Skip adding readers (you can add them later)
              </div>
            </div>
          </div>
        </div>
      ) : (
        <EmbeddedReaderManagement
          onComplete={handleAddReaders}
          onBack={() => setMode(null)}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          stepData={stepData}
        />
      )}

      <style jsx>{`
        .readers-step {
          text-align: center;
        }

        .readers-content {
          padding: 20px 0;
        }

        .readers-icon {
          font-size: 64px;
          margin-bottom: 24px;
          color: var(--color-primary);
        }

        .readers-info {
          margin: 32px 0;
          text-align: left;
          max-width: 400px;
          margin-left: auto;
          margin-right: auto;
        }

        .info-item {
          display: flex;
          align-items: flex-start;
          gap: 12px;
          margin-bottom: 20px;
          padding: 16px;
          background: var(--color-background);
          border-radius: 8px;
          border: 1px solid var(--color-border);
        }

        .info-icon {
          font-size: 20px;
          flex-shrink: 0;
          margin-top: 2px;
        }

        .info-text {
          font-size: 14px;
          color: var(--color-text-secondary);
          line-height: 1.4;
        }

        .info-text strong {
          color: var(--color-text);
          display: block;
          margin-bottom: 4px;
        }

        .readers-actions {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 20px;
          margin: 32px 0;
        }

        .action-card {
          padding: 24px 20px;
          border: 2px solid var(--color-border);
          border-radius: 12px;
          cursor: pointer;
          transition: all 0.2s ease;
          background: var(--color-surface);
        }

        .action-card:hover {
          border-color: var(--color-primary);
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }

        .action-card.skip-card {
          border-style: dashed;
          opacity: 0.8;
        }

        .action-icon {
          font-size: 32px;
          margin-bottom: 16px;
        }

        .action-title {
          font-size: 16px;
          font-weight: 600;
          color: var(--color-text);
          margin-bottom: 8px;
        }

        .action-description {
          font-size: 14px;
          color: var(--color-text-secondary);
          line-height: 1.4;
        }

        @media (max-width: 768px) {
          .readers-actions {
            grid-template-columns: 1fr;
          }

          .readers-info {
            max-width: 100%;
          }
        }
      `}</style>
    </div>
  );
};

export default OnboardingStep5Readers;
